export default __webpack_public_path__ + "static/2-674cef7f6fe20d11a9a0c44fc1ca8f27.jpg";